// ----------------------------------------------------------------------

/**
 * One focus ring everywhere (Cabinet Base): a 2px primary outline 1px off the
 * control, with a soft halo outside it. Keyboard focus only — MUI sets
 * `.Mui-focusVisible` on every ButtonBase-derived control (buttons, icon
 * buttons, menu items, tabs, checkboxes) when focus came from the keyboard.
 * The ring clears 3:1 on every surface in both themes.
 */
export default function Focus(theme) {
    return {
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    '&.Mui-focusVisible': {
                        outline: `2px solid ${theme.palette.focus.ring}`,
                        outlineOffset: 1,
                        boxShadow: `0 0 0 4px ${theme.palette.focus.halo}`,
                    },
                },
            },
        },
    };
}
